import React from 'react'
import {BrowserRouter, HashRouter, Route, Switch, Redirect} from 'react-router-dom'
import App from './App'
import Admin from './admin'
import Home from './pages/home';

import Goods from "./pages/goods";
import AddGoods from "./pages/goods/add-goods";
import EditGoods from "./pages/goods/edit-goods";
import HeadShop from "./pages/headshop";
import Order from "./pages/order";
import Orders from "./pages/orders";
import Recycle from "./pages/recycle";
import Finance from "./pages/finance";
import Collection from "./pages/collection";

import ShopRenovation from "./pages/shopmanage/shoprenovation";
import ShopMessage from "./pages/shopmanage/shopmessage";
import DeliveryManage from "./pages/shopmanage/deliverymanage";
import Showcase from "./pages/shopmanage/shoprenovation/showcase";
import Feature from "./pages/shopmanage/shoprenovation/feature";
import Poster from "./pages/shopmanage/shoprenovation/poster";
import AddPoster from "./pages/shopmanage/shoprenovation/poster/add";
import EditArea from "./pages/shopmanage/deliverymanage/editarea";
import EditAreaFlower from "./pages/shopmanage/deliverymanage/editarea-flower";
import AddFlowerGoods from './pages/flower/goods/add-goods'
import EditFlowerGoods from './pages/flower/goods/edit-goods'
import Activitys from "./pages/activitys";
import Progress from './pages/activitys/add-activity'

import Progress2 from './pages/activitys/edit-activity'

import EditRecycleGoods from './pages/recycle/edit-goods'

import Login from './pages/login'
import {getToken} from "./utils/cookie";

import {COMMON_ROUTER} from "./constants";

export default class ERouter extends React.Component {

  render() {
    return (
      <HashRouter>
        <App>
          <Switch>
          <Route exact path="/login" component={Login}/>
            <Route path={COMMON_ROUTER} render={() =>
                !getToken()?<Redirect to='/login' />:
              <Admin>
                <Switch>
                  <Route path={COMMON_ROUTER + "/goods/add-goods"} component={AddFlowerGoods}/>
                  <Route path={COMMON_ROUTER + "/goods/edit-goods"} component={EditFlowerGoods}/>
                  <Route path={COMMON_ROUTER + "/recycle/edit-goods"} component={EditRecycleGoods}/>

                  <Route path={COMMON_ROUTER + "/home"} component={Home}/>
                  <Route path={COMMON_ROUTER + "/headShop"} component={HeadShop}/>
                  <Route path={COMMON_ROUTER + "/goods"} component={Goods}/>
                  <Route path={COMMON_ROUTER + "/addGoods"} component={AddGoods}/>
                  <Route path={COMMON_ROUTER + "/editGoods"} component={EditGoods}/>
                  <Route path={COMMON_ROUTER + "/order"} component={Order}/>
                  <Route path={COMMON_ROUTER + "/orders"} component={Orders}/>
                  <Route path={COMMON_ROUTER + "/recycle"} component={Recycle}/>
                  <Route path={COMMON_ROUTER + "/finance"} component={Finance}/>
                  <Route path={COMMON_ROUTER + "/collection"} component={Collection}/>

                  <Route path={COMMON_ROUTER + "/shopRenovation"} component={ShopRenovation}/>
                  <Route path={COMMON_ROUTER + "/showcase"} component={Showcase}/>
                  <Route path={COMMON_ROUTER + "/poster"} component={Poster}/>
                  <Route path={COMMON_ROUTER + "/editArea"} component={EditArea}/>
                  <Route path={COMMON_ROUTER + "/editAreaFlower"} component={EditAreaFlower}/>

                  <Route path={COMMON_ROUTER + "/add/addPoster"} component={AddPoster}/>
                  <Route path={COMMON_ROUTER + "/feature"} component={Feature}/>
                  <Route path={COMMON_ROUTER + "/shopMessage"} component={ShopMessage}/>
                  <Route path={COMMON_ROUTER + "/deliveryManage"} component={DeliveryManage}/>

                  <Route path={COMMON_ROUTER + "/activitys/add-activity"} component={Progress}/>
                  <Route path={COMMON_ROUTER + "/activitys/edit-activity"} component={Progress2}/>
                  <Route path={COMMON_ROUTER + "/activitys"} component={Activitys}/>

                  <Redirect to={COMMON_ROUTER + "/order"}/>
                  {/* <Route component={NoMatch} /> */}

                </Switch>
              </Admin>
            }/>
          </Switch>
        </App>
      </HashRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/router.js